import { FileSelectionHelper } from "@/Common/Helpers/FileSelectionHelper";
import { FileType } from "@/Common/Models/FileType";
import { ExportableFile, IExportableFile, IExportableFileLoaded } from "../ExportableFile";
import { GenerateFileOptions } from "../IGenerateFileOptions";
import { FileTypeTemporaryFile } from "./FileTypeTemporaryFile";

interface IFileTypePatientGrowthChart extends IExportableFile {
    chartId: string;
    ObjectId?: string;
}

class FileTypePatientGrowthChart extends ExportableFile implements IFileTypePatientGrowthChart {
    public canGenerateFileXcom: boolean = true;

    public chartId: string;
    public ObjectId: string;

    constructor(fields: IFileTypePatientGrowthChart) {
        super(FileType.PatientGrowthChart);
        this.chartId = fields.chartId;
        this.ObjectId = fields.ObjectId;
        this.date = fields.date;
        this.description = fields.description;
    }

    public getAttachedObject_ObjectId(): string {
        return this.ObjectId ?? this.chartId;
    }

    public getCleanCopy(): FileTypePatientGrowthChart {
        return new FileTypePatientGrowthChart(this);
    }

    protected async generateFileIfNeededXcom(includeOverlays: boolean): Promise<IExportableFileLoaded> {
        return await this.generateFileIfNeeded({ includeOverlays: includeOverlays, isExternal: true });
    }

    protected generateFileIfNeeded(generateFileOption: GenerateFileOptions): Promise<IExportableFileLoaded> {
        const { isExternal } = generateFileOption;

        let fetchUrl =
            isExternal
                ? FileSelectionHelper.getFetchUrlXcom(this.clientTag, this.claimId, this.chartId, this.fileType)
                : FileSelectionHelper.getFetchUrl(this.chartId, this.fileType);

        if (!this.chartId && this.ObjectId) {
            const tempFile = new FileTypeTemporaryFile({
                ObjectId: this.ObjectId,
                description: this.description,
                date: this.date
            });
            fetchUrl = tempFile.FetchUrl;
        }

        return new Promise(resolve => resolve({
            OriginalExportableFile: this,
            FetchUrl: fetchUrl
        }));
    }

    public getMeta(): Promise<number> {
        throw new Error("Method not implemented.");
    }
}

export { FileTypePatientGrowthChart };
